import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  constructor(@Inject(DOCUMENT) private document: any) { }

  ngOnInit() {
    if (environment.name !== 'development') {
      this.document.location.href = environment.errorUrl;
    }
  }
}
